<app-header [isErrorPage]="true" />
<div class="error-page">
    <div class="error-page-container">
        <div class="error-image">
            <img [src]="errorImages[errorNumber]" alt="Error">
        </div>
        <div class="error-container">
            <span class="error-code">{{ errorNumber }}</span>
            <span class="error-message-header">{{ ('ERROR_PAGE.' + errorNumber + '.HEADER') | translate }}</span>
            <p class="error-message" [innerHTML]="('ERROR_PAGE.' + errorNumber + '.MESSAGE') | translate"></p>
            <div class="error-buttons">
                <button *ngIf="showHomeButton()" class="outline-btn" (click)="navigateToHome()">
                    <span class="material-symbols-outlined ico-list"> home </span>
                    <div style="display: flex; flex-direction: column; padding-right: 10px;">
                        {{ "BUTTON.HOME" | translate }}
                    </div>
                </button>
                <button *ngIf="showLoginButton()" class="outline-btn" (click)="navigateToLogin()">
                    <span class="material-symbols-outlined ico-list"> person </span>
                    <div style="display: flex; flex-direction: column; padding-right: 10px;">
                        {{ "BUTTON.LOGIN" | translate }}
                    </div>
                </button>
            </div>
        </div>
    </div>
</div>
